import { render, staticRenderFns } from "./editShopReturnAddress.vue?vue&type=template&id=16892157"
import script from "./editShopReturnAddress.vue?vue&type=script&lang=js"
export * from "./editShopReturnAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports